import "./style.css";

const ReviewsSection = (props: any) => {

    return (
        <div data-bv-show="reviews" data-bv-product-id={props.sku} className="product-page-rating-container" ></div>
    )

}

export default ReviewsSection;